module.exports = __webpack_public_path__ + "main/assets/public/button/left-arrow.732206df0ce88b01.svg";